import Loading, { TypeLoading } from "./Loading";

export default {
    View: Loading,
    type: TypeLoading,
};
